import { playDeath } from '@components/sound/Sound';
import { defaultText } from '@phaser/helpers/Text';
import { DEPTH } from '@phaser/data/depth';
import { Game } from '@phaser/scenes/Game';
import { useLobbyStore } from '@stores';
import i18next from 'i18next';

export class RespawnSystem {
  private _scene = Game.current;

  private _timeLeft = 0;

  private _timer?: Phaser.GameObjects.Text;
  private _background?: Phaser.GameObjects.Rectangle;
  private _infoText?: Phaser.GameObjects.Text;

  constructor() {}

  public update(_time: number, delta: number) {
    this._updateTimer(delta);
  }

  public respawnPlayer(countdown: number) {
    this._timeLeft = countdown * 1000;
    if (!this._timer) this._createTimer();
  }

  public destroy() {
    this._timeLeft = 0;

    this._timer?.destroy();
    this._timer = undefined;
    this._infoText?.destroy();
    this._infoText = undefined;
    this._background?.destroy();
    this._background = undefined;
  }

  private _createTimer() {
    const camera = this._scene.cameras.main;
    const width = camera.displayWidth;
    const height = camera.displayHeight;

    const isSolo = (useLobbyStore.getState().state?.players.length ?? 1) <= 1;

    this._background = this._scene.add.rectangle(0, 0, width, height, 0x000000, 0.9)
      .setDepth(DEPTH.RESPAWN_BACKGROUND)
      .setOrigin(0);

    const text = i18next.t(isSolo ? 'Game.youDied' : 'Game.respawningIn');
    const offset = isSolo ? 0 : 32;

    this._infoText = this._scene.add.text(width / 2, height / 2 - offset, text, {
      ...defaultText,
      strokeThickness: 0,
      fontSize: '24px',
    })
    .setOrigin(0.5)
    .setDepth(DEPTH.RESPAWN);

    this._timer = this._scene.add.text(width / 2, height / 2, '00:00', {
      fontFamily: 'Kode Mono Variable',
      fontSize: '32px',
      color: '#ffffff',
      resolution: 3,
    })
    .setOrigin(0.5)
    .setDepth(DEPTH.RESPAWN)
    .setAlpha(isSolo ? 0 : 1);

    playDeath();
  }

  private _updateTimer(delta: number) {
    if (this._timeLeft <= 0) return;

    this._timeLeft -= delta;
    if (this._timeLeft <= 0) return this.destroy();

    const seconds = Math.floor(this._timeLeft / 1000);
    const milliseconds = Math.floor(this._timeLeft % 1000);
    const ss = seconds.toString().padStart(2, '0');
    const mmm = milliseconds.toString().padStart(3, '0');
  
    this._timer?.setText(`${ss}:${mmm}`);
  }
}